import { getSuggestedAddresses } from '../../../services/address';
import { useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';

const SMARTY_QUERY_DEBOUNCE_IN_MS = 300;

export const useGetSuggestedAddresses = (userInput: string) => {
  const [debouncedUserInput] = useDebounce(userInput, SMARTY_QUERY_DEBOUNCE_IN_MS);

  const { data, isLoading } = useQuery({
    enabled: !!debouncedUserInput,
    queryKey: ['suggestedAddresses', debouncedUserInput],
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: () => getSuggestedAddresses(debouncedUserInput),
  });

  return { suggestedAddressesData: data, isLoadingSuggestedAddressesData: isLoading };
};
